import http from '@/lib/http';
import { Message } from 'element-ui';

export default {

    async getAdList() {
        try {
            let res = await http.get('/api/suggestion/all');
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },
}
